export default __webpack_public_path__ + "static/media/step2.984fedf5.png";